export const profil = {
  namespaced: true,
  state: {
    user: null,
    authentication: null,
  },
  actions: {
    clear({ state }) {
      state.user = null
      state.authentication = null
    }
  },
  mutations: {
    save(state, profil) {
      if(profil.hasOwnProperty('user')) {
          state.user = profil.user
      }

      if(profil.hasOwnProperty('authentication')) {
          state.authentication = profil.authentication
      }
    },
  },
};
